import { getRequestConfig } from 'next-intl/server'
import { createNavigation } from 'next-intl/navigation'
import { Pathnames } from 'next-intl/routing'

export const localePrefix = 'always' // todo -- Modify this to 'as-needed' when the english lan is introduced

export const supportedLocales: CustomLocale['locale'][] = [/*'en',*/ 'sv', 'no', 'da']
export const defaultLocale = 'sv'

export type CustomLocale = {
  locale: 'sv' | 'no' | 'da' | 'en'
}

export const pathnames = {
  '/varumarken': {
    no: '/varemerker',
    sv: '/varumarken',
    da: '/varemarker',
    en: '/brands'
  },

  '/varumarken/[slug]': {
    no: '/varemerker/[slug]',
    sv: '/varumarken/[slug]',
    da: '/varemarker/[slug]',
    en: '/brands/[slug]'
  },
  '/categories/[slug]': {
    no: '/kategorier/[slug]',
    sv: '/kategorier/[slug]',
    da: '/kategorier/[slug]',
    en: '/categories/[slug]'
  },
  '/p/[slug]': {
    no: '/produkter/[slug]',
    sv: '/produkter/[slug]',
    da: '/produkter/[slug]',
    en: '/products/[slug]'
  },
  '/blog/[slug]': {
    no: '/blogg/[slug]',
    sv: '/blogg/[slug]',
    da: '/blog/[slug]',
    en: '/blog/[slug]'
  }
} satisfies Pathnames<typeof supportedLocales>

export default getRequestConfig(async ({ requestLocale }) => {
  // This typically corresponds to the `[locale]` segment
  let locale = await requestLocale

  // Ensure that the incoming locale is valid
  if (!locale || !supportedLocales.includes(locale as any)) {
    locale = defaultLocale
  }

  return {
    locale,
    messages: (await import(`./custom/intl/${locale}.json`)).default
  }
})

export function i18nLocalizePath(path: string, locale: CustomLocale['locale']): string {
  if (locale === defaultLocale) {
    return path
  }

  return `/${locale}${path}`
}

export const SharedPathnamesNav = createNavigation({
  locales: supportedLocales,
  localePrefix
})

/**
 * Switches market with a full document navigation instead of a soft router push.
 * Nav links are locale-less (`/kategorier/x`) and resolved by the middleware via the
 * NEXT_LOCALE cookie. A soft switch keeps the client router cache, which still holds
 * the prefetched redirects to the previous locale (`/kategorier/x` -> `/sv/kategorier/x`),
 * so the next click lands in the old market. A full load drops that cache.
 */
export function switchMarket(locale: CustomLocale['locale']) {
  window.location.assign(SharedPathnamesNav.getPathname({ href: '/', locale }))
}
